import { customElement, autoinject, bindable } from 'aurelia-framework';
import { InputBase } from '../inputBase';

@customElement('form-input-readonly')
@autoinject()
export class FormInputText extends InputBase<string> {
    @bindable disabled: boolean = false;
}
